import axios from "axios";

export class OfertasLaboralesService {
  constructor(type) {
    this.url = process.env.REACT_APP_API_URL + "ofertalaboral";
    this.type = type;
    this.token = process.env.REACT_APP_JWT_SECRET;
    this.url_bff = process.env.REACT_APP_URL_BFF;
  }

  async requestWithRetry(url, method = 'GET', data = null, config = {}, maxRetries = 3, delay = 1000) {
    let lastError = null;
    for (let i = 0; i < maxRetries; i++) {
      try {
        const response = await axios({
          method: method,
          url: url,
          data: data,
          ...config
        });
        return response;
      } catch (error) {
        if (error.response && error.response.status === 503) {
          // Backoff delay for 503 errors
          await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
        } else if (error.message.includes('CORS')) {
          // If it's a CORS error, break out of the loop
          throw error;
        }
        lastError = error;
      }
    }
    throw lastError;
  }

  getOfertasLaborales(resource) {
    const config = {
      headers: { authorization: `${this.token}` },
    };
    return this.requestWithRetry(
      `${this.url_bff}/bff-sgdt-job-offer/api/ofertalaboral/${this.type}/${resource}`,
      'GET',
      null,
      config
    );
  }

  getAllOfertasLaborales() {
    const config = {
      headers: { authorization: `${this.token}` },
    };
    return this.requestWithRetry(
      `${this.url_bff}/bff-sgdt-job-offer/api/ofertalaboral/type/${this.type}`,
      'GET',
      null,
      config
    );
  }

  getOfertasLaboralesByFilter(resource) {
    const config = {
      headers: { authorization: `${this.token}` },
    };
    return this.requestWithRetry(
      `${this.url_bff}/bff-sgdt-job-offer/api/ofertalaboral/filter`,
      'POST',
      resource,
      config
    );
  }

  postLoggingMuevete(eventType, userDetails, deviceInfo) {
    const postData = { eventType, userDetails, deviceInfo };
    return this.requestWithRetry(
      `${this.url_bff}/bff-sgdt-job-offer/api/ofertalaboral/logEvent`,
      'POST',
      postData
    );
  }

  getVideo(fileName) {
    const config = {
      headers: {
        authorization: `${this.token}`,
        'Content-Type': 'video/mp4',
      },
      responseType: 'blob',
    };
    return this.requestWithRetry(
      `${this.url_bff}/bff-sgdt-job-offer/api/ofertalaboral/media/${fileName}`,
      'GET',
      null,
      config
    );
  }
}
